export enum LayoutType {
  DEFAULT = 'default',
  MOBILE = 'mobile',
  OFFLINE = 'offline',
}
export interface PageLayoutComponentProps {
  disabled: boolean
}

export interface ConsumerTopBarLayout {
  search: PageLayoutComponentProps
}
export interface PreviewTopBarLayout {
  productContent: PageLayoutComponentProps
}
export interface PageLayout {
  consumerTopBar?: ConsumerTopBarLayout
  previewTopBar?: PreviewTopBarLayout
}

export type PageLayouts = Partial<Record<LayoutType, PageLayout>>